import { bool } from "prop-types";
import { observer } from "mobx-react";
import { APP_BAR_HEIGHTS } from "@styles/themes";
import {
  EditorContainer,
  EstimateEditorSettingsProvider,
  PdfEditorContainer,
  ProposalStepper,
} from "@tools";
import { EditorContent, PdfEstimateContent, PresetToolbar } from "./index";

export const EditorRoot = observer(({
  hasEditorPrivileges,
  hasSellerPrivileges,
  showStepper,
  showPdfCover,
  showPresetToolbar,
  showUserMovement,
  ...providerProps
}) => (
  <EstimateEditorSettingsProvider
    hasEditorPrivileges={ hasEditorPrivileges }
    hasSellerPrivileges={ hasSellerPrivileges }
    showPdfCover={ showPdfCover }
    { ...providerProps }
  >
    { showStepper && <ProposalStepper /> }
    { showPresetToolbar && <PresetToolbar /> }
    {
      showPdfCover
        ? (
          <PdfEditorContainer
            offsetTop={ hasSellerPrivileges ? APP_BAR_HEIGHTS.LARGE : 0 }
            noShareActions={ !hasSellerPrivileges }
            showPageImages={ !hasSellerPrivileges }
            noThumbnailListRescale
            proposalSharing
            noThumbButton
            noFileAppends
          >
            <PdfEstimateContent />
          </PdfEditorContainer>
        )
        : (
          <EditorContainer
            showUserMovement={ showUserMovement }
            showPresetToolbar={ showPresetToolbar }
          >
            <EditorContent />
          </EditorContainer>
        )
    }
  </EstimateEditorSettingsProvider>
));

EditorRoot.propTypes = {

  hasEditorPrivileges: bool,
  hasSellerPrivileges: bool,
  readOnly: bool,
  isProposal: bool,
  isPresetEditor: bool,
  allowInteractions: bool,
  useRecorderFriendlyPdf: bool,
  noTurningOff: bool,
  noCommenting: bool,
  showRowGroupBorders: bool,
  
  showStepper: bool,
  showPdfCover: bool,
  showPresetToolbar: bool,
  showUserMovement: bool,
};

EditorRoot.displayName = "EditorRoot";